import { useState } from 'react';

import { DEFAULT_ENTRIES_PER_PAGE } from '../../constants';
import { StorageEntity } from '../../utils/storages/storageEntity';
import { PaginationStorage, PaginationStorageKey, UsePagination } from './types';

type Props = {
  storage?: StorageEntity<PaginationStorage>;
};
const usePagination = ({ storage }: Props = {}): UsePagination => {
  const [currentPage, setPage] = useState<number>(0);

  const [entriesPerPage, setEntriesPerPage] = useState<number>(() => {
    return storage?.getStorageData(PaginationStorageKey.entriesPerPage) || DEFAULT_ENTRIES_PER_PAGE;
  });

  const setCurrentPage = (currentPage: number): void => {
    setPage(currentPage);
  };

  const handleEntriesPerPage = (newValue: string): void => {
    const newEntriesPerPage = Number(newValue);
    if (!newEntriesPerPage) return;
    setEntriesPerPage(newEntriesPerPage);
    if (storage) {
      storage.setStorageData(PaginationStorageKey.entriesPerPage, newEntriesPerPage);
    }
    setCurrentPage(0);
  };

  const handleChangePage = (_: React.MouseEvent<HTMLElement> | null, page: number): void => {
    setCurrentPage(page);
  };

  return {
    paginationOptions: {
      currentPage,
      entriesPerPage,
    },
    handleEntriesPerPage,
    handleChangePage,
    setCurrentPage,
  };
};

export default usePagination;
